import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.scss";

export type TabType = "uContract" | "fiatContract";

interface TabSwitchProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  onDepositClick?: () => void;
  /** 是否展示法币 tab（由 fiatCurrencyIds + IP + 余额 决策，都不命中时不展示） */
  showFiatTab?: boolean;
}

const TabSwitch: React.FC<TabSwitchProps> = ({
  activeTab,
  onTabChange,
  onDepositClick,
  showFiatTab = true,
}) => {
  const t = useTranslation();

  return (
    <div className={styles.tabSwitch}>
      <div className={styles.tabs}>
        {showFiatTab && (
          <button
            className={cx(styles.tab, { [styles.active]: activeTab === "fiatContract" })}
            onClick={() => onTabChange("fiatContract")}
          >
            {t("cfd.fiatContract")}
          </button>
        )}
        <button
          className={cx(styles.tab, { [styles.active]: activeTab === "uContract" })}
          onClick={() => onTabChange("uContract")}
        >
          {t("cfd.uContract")}
        </button>
      </div>
      {onDepositClick && (
        <button className={styles.depositBtn} onClick={onDepositClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
            <path d="M1.83232 8.51477H13.9579" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.71249 16.2751H7.65258" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.0777 16.2751H13.9578" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.2332 13.8791V15.8968C21.2332 19.3016 20.3699 20.1553 16.9262 20.1553H6.13932C2.69567 20.1553 1.83233 19.3016 1.83233 15.8968V7.92304C1.83233 4.51819 2.69567 3.66455 6.13932 3.66455H13.9579" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.2931 3.66455V9.48481L21.2332 7.54472" stroke="#B9F78A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.2931 9.48476L17.353 7.54468" stroke="#B9F78A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default observer(TabSwitch);
